import * as React from 'react';
import b_ from 'b_';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { form, FormProps } from 'shared/utils/form';
import { validate } from 'shared/utils/validators';
import { track } from 'shared/utils/track';
import { routine, lifecycle } from './actions';
import { FormData, constraints } from './constraints';
import { mapStateToProps } from './selectors';
import { Button } from './components/Button';
import AmountInput from './components/AmountInput';

import './index.scss';

export interface Props {
  id: number;
  form: string;
}

type Enhanced = Props & ReturnType<typeof mapStateToProps> & FormProps<FormData>;

const enhance = compose<Enhanced, Props>(
  track(lifecycle),
  connect(mapStateToProps),
  form<FormData, Props>(routine, {
    validate: (values) => validate(constraints, values),
    destroyOnUnmount: true,
    initialValues: { quantity: '1' },
  })
);

const b = b_.with('stock-submit-section');

const StockSubmitSection: React.FC<Enhanced> = ({
  id,
  quantity,
  formSubmit,
  submitting,
  error,
}) => (
  <form className={b()} onSubmit={formSubmit}>
    <AmountInput name="quantity" />
    <Button stockId={id} quantity={+quantity || 0} submitting={submitting} error={error} />
  </form>
);

export default enhance(StockSubmitSection);
